import { ButtonProps, Theme } from "@material-ui/core"

function isPrimaryOrSecondary(color: ButtonProps["color"]): color is "primary" | "secondary" {
  return (color && color === "primary") || color === "secondary"
}

type TButtonColorParams<T extends ButtonProps> = T & { theme: Theme }

export function buttonMainColor<T extends ButtonProps>({ theme, color }: TButtonColorParams<T>) {
  if (isPrimaryOrSecondary(color)) return theme.palette[color].main
  return color === "default" ? theme.palette.grey[300] : "currentColor"
}

export function buttonReverseColor<T extends ButtonProps>({ theme, color }: TButtonColorParams<T>) {
  if (isPrimaryOrSecondary(color)) return theme.palette.common.white
  return color === "default" ? "initial" : "inherit"
}
